// ============================================================================
// Шрифты маркетингового лендинга (СКОУП ТОЛЬКО ЛЕНДИНГ)
// ============================================================================
// Onest — единая гарнитура бренда (Brand Book v2.0), весь UI лендинга.
// Space Grotesk — цифры, цены, коды, eyebrow. Была Manrope.
// Подключаются как CSS-переменные и навешиваются на корневую обёртку
// LandingMarketingView, чтобы НЕ затрагивать остальной продукт
// (у него те же шрифты, но свои переменные — --font-sans и --font-grotesk).

// 960: сами шрифты — в lib/fonts, одно место на весь продукт.
import { landingSans, landingMono } from '@/lib/fonts'

/** Класс-обёртка: навешивает обе переменные шрифтов на контейнер лендинга. */
export const landingFontVars = `${landingSans.variable} ${landingMono.variable}`

/**
 * Моноширинный набор лендинга — цифры, цены, коды.
 *
 * Был объявлен в трёх компонентах отдельно. Живёт здесь, рядом со шрифтами,
 * потому что это часть брендбука лендинга, а не общая настройка приложения.
 */
export const MONO = 'var(--font-landing-mono), monospace'
